import {gql} from '@apollo/client';

export const SUBMIT_PILOT_LEAD = gql`
  mutation SubmitPilotLead($input: PilotLeadInput!) {
    submitPilotLead(input: $input) {
      ok
      leadId
    }
  }
`;
